import * as angular from "angular";
import {IController, IScope} from "angular";


export class ShipperListItemCtrl implements IController {
  id: string;
  large: any;

  constructor(private $scope: IScope, private $shipper) {
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$shipper(this.id).$bindCtrl(this.$scope, this, 'shipper');
    }
  }


}

angular
  .module('bringoz.admin.shippers')
  .component('shipperListItem', {
    bindings: {
      id: '<',
      large: '<?'
    },
    template: require('./shipper-list-item.html').default,
    controller: ShipperListItemCtrl
  });
